import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import {mergeObjects} from "@/utils/utils";
import Config from "@/config";
import routes from './routes';
import {mapRouteQuery} from "@/utils/context";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    //base: process.env.BASE_URL,
    routes
});

router.beforeEach(async (to, from, next) => {
    await store.commit("uiInitBeforeRouting", {to, from});

    /*if ( store.state.session.user ) {
        // when session exists we load data BEFORE routing
        await loadData(to, from);
    }*/

    next();
});
router.afterEach(async (to, from) => {

    // загружаем данные сессии пользователя
    if (!to.meta?.skipSession) {
        await store.dispatch("user/session");
    }

    await loadData(to, from);

    // pause to allow fade out
    /*setTimeout(async ()=>{
        // загружаем данные сессии пользователя
        if (!to.meta?.skipSession) {
            await store.dispatch("user/session");
        }

        await loadData(to, from);
    },Config.ROUTING_FADE_IN_TIME); // this shoul be a little more to allow mutation clear beforeEach*/
});

const loadData = (to, from) => {
    const isAnon = store.state.session.isAnon;

    let loads = [];
    // загружаем данные текущего роута
    if (!to.params?.apiless && (to.meta?.api || to.meta?.action || to.meta?.actions)) {
        let actions;

        if (to.meta.actions) {
            actions = to.meta.actions;
        } else if (to.meta.action) {
            actions = [{
                action: to.meta.action,
                params: to.meta.params,
                query: to.meta.query,
                withAnon: to.meta.withAnon,
            }];
        } else {
            // api style
            actions = [{
                action: 'fetchPage',
                method: to.meta.method,
                params: to.meta.params,
                query: to.meta.query,
                withAnon: to.meta.withAnon,
            }];
        }

        actions?.filter(el => !isAnon || el.withAnon).forEach(action => {
            const query = mapRouteQuery(to.query, action.queryMap);
            //console.log("IS CONTEXT", action.isContext, action.skipError);
            if (action.isContext && to.params?.skipContext) return;
            if (action.isTask && to.params?.skipTask) return;
            const options = {
                //method: action.method || "GET",
                action: action.action,
                isContext: action.isContext,
                withErrorHandler: action.withErrorHandler,
                params: {
                    ...{},
                    ...action.params,
                    ...to.params,
                    ...query,
                },
                subscribe: action.subscribe
            };
            //loads.push(store.dispatch("get", options));
            loads.push(store.dispatch("action", options));
        });
    }

    return new Promise(async (resolve, reject) => {
        const values = await Promise.all(loads).catch((err) => {
            console.warn("API error for route " + to.name, err);
            if (err.code === Config.API_EXCEPTION_CODE_403) {
                //router.replace({name: 'auth'});
            } else if (err.code === Config.API_EXCEPTION_CODE_404) {
                //router.replace({name: 'error404'});
            } else {
                router.replace({name: 'error500'});
            }
        });

        setTimeout(() => {
            store.commit("uiValidateRoute", {to, from});
            if (store.state.ui.isValidRoute) {
                store.commit("uiSetTitle", {to, from});
                store.commit("uiInitAfterRouting", {to, from});
                resolve();
            }
        }, 50);
    });
}

/*router.afterEach((to, from) => {
    store.state.routingTo = null;
    store.state.withContextList = false;

    // небольшая задержка, чтобы в браузере сменился URL
    setTimeout(() => {
        // сообщаем Метрике явно, на какой URL пришли:
        //metrika.hit();

        // scroll to top
        window.scrollTo({
            'behavior': 'auto', //'smooth',
            'left': 0,
            'top': 0
        });

        store.state.isRoutingPending = false;

        // сообщаем в ГТМ, что страница доступна
        // if(typeof dataLayer) dataLayer.push({'event': 'render-event'});
    }, 500);

    // сообщаем пререндереру, что страница загрузилась:
    setTimeout(() => {
        document.dispatchEvent(new Event('render-event'));
    }, 1000);
});*/

export default router;

